import { createFileRoute } from "@tanstack/react-router";
import Pricing from "@/pages/Pricing";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/zh/pricing")({
  head: () => pageHead("/pricing", "zh"),
  component: Pricing,
});
